import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "w-1/2 font-bold border border-next-dark-gray" }
const _hoisted_2 = { class: "w-1/2 border border-next-dark-gray" }
const _hoisted_3 = { class: "flex justify-between pt-3" }
const _hoisted_4 = { class: "m-auto px-8 pb-8" }
const _hoisted_5 = { class: "m-auto pt-5" }
const _hoisted_6 = { class: "flex items-center justify-between" }
const _hoisted_7 = { class: "text-3xl font-bold mb-4" }
const _hoisted_8 = { class: "flex flex-col col-span-2 mb-2" }
const _hoisted_9 = { class: "flex justify-end" }
const _hoisted_10 = { class: "rotate-x-180 overflow-x-scroll" }
const _hoisted_11 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_NextTable = _resolveComponent("NextTable")!
  const _component_InfiniteLoading = _resolveComponent("InfiniteLoading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Loading, {
        visible: _ctx.lista.loading
      }, null, 8, ["visible"]),
      _createVNode(_component_Modal, {
        visible: _ctx.show_detail,
        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.show_detail) = $event)),
        backdrop: ""
      }, {
        header: _withCtx(() => _cache[4] || (_cache[4] = [
          _createElementVNode("h2", { class: "text-2xl font-bold" }, "Dettaglio", -1)
        ])),
        main: _withCtx(() => [
          _createElementVNode("table", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail, (v, k) => {
              return (_openBlock(), _createElementBlock("tr", { key: k }, [
                _createElementVNode("td", _hoisted_1, _toDisplayString(k) + ":", 1),
                _createElementVNode("td", _hoisted_2, _toDisplayString(v), 1)
              ]))
            }), 128))
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_NextButton, {
              variant: "outline-secondary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show_detail =false)),
              class: "py-2 px-4 w-full"
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode(" Chiudi ")
              ])),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h2", _hoisted_7, "Costi note spesa: " + _toDisplayString(_ctx.lista.rows[0]?.nodo || '---'), 1),
          _createVNode(_component_NextButton, {
            disabled: _ctx.loading_download,
            variant: "secondary",
            class: "p-2",
            onClick: _ctx.export_data
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode("Esporta")
            ])),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Field, {
            field_name: "Cerca",
            "onUpdate:modelValue": [
              _ctx.lista.debounceSearch,
              _cache[2] || (_cache[2] = ($event: any) => ((_ctx.lista.search) = $event))
            ],
            modelValue: _ctx.lista.search,
            placeholder: "Cerca"
          }, null, 8, ["onUpdate:modelValue", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Paginator, {
            class: "",
            pagination: _ctx.lista.paginate
          }, null, 8, ["pagination"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_NextTable, {
            class: "rotate-x-180 border-separate border-spacing-3 table-fixed",
            cols: _ctx.cols,
            "onUpdate:cols": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cols) = $event)),
            rows: _ctx.lista.rows,
            onOrderUpdate: _ctx.lista.updateCols
          }, _createSlots({ _: 2 }, [
            _renderList(_ctx.lista.rows, (c, j) => {
              return {
                name: `td_${j}_1`,
                fn: _withCtx((context) => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.toDate(c.Data_spesa)), 1)
                ])
              }
            }),
            _renderList(_ctx.lista.rows, (c, j) => {
              return {
                name: `td_${j}_3`,
                fn: _withCtx((context) => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.toCurrency(c.importo_in_valuta)), 1)
                ])
              }
            }),
            _renderList(_ctx.lista.rows, (c, j) => {
              return {
                name: `td_${j}_5`,
                fn: _withCtx((context) => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.toFormat(c.Cambio, 0, 0)), 1)
                ])
              }
            }),
            _renderList(_ctx.lista.rows, (c, j) => {
              return {
                name: `td_${j}_6`,
                fn: _withCtx((context) => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.toEuroCurrency(c.importo_Euro)), 1)
                ])
              }
            }),
            _renderList(_ctx.lista.rows, (c, j) => {
              return {
                name: `td_${j}_10`,
                fn: _withCtx((context) => [
                  _createElementVNode("span", {
                    onClick: ($event: any) => (_ctx.showData(c)),
                    class: "text-center inset-0 absolute flex items-center justify-center"
                  }, _cache[7] || (_cache[7] = [
                    _createElementVNode("i", { class: "icon-chevron_destra" }, null, -1)
                  ]), 8, _hoisted_11)
                ])
              }
            })
          ]), 1032, ["cols", "rows", "onOrderUpdate"])
        ]),
        _createVNode(_component_InfiniteLoading, {
          onInfinite: _ctx.lista.fetchNextPage,
          identifier: _ctx.lista.infiniteIdentifier,
          style: {"min-height":"1px"}
        }, {
          complete: _withCtx(() => _cache[8] || (_cache[8] = [
            _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altre righe.", -1)
          ])),
          _: 1
        }, 8, ["onInfinite", "identifier"])
      ])
    ])
  ], 64))
}